import React from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10000,
};

const dialogStyle = {
  background: "#1a1a2e",
  color: "#f5f5f5",
  border: "1px solid #c9a961",
  borderRadius: "8px",
  padding: "28px 32px",
  maxWidth: "420px",
  width: "90%",
  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.5)",
  textAlign: "center",
  fontFamily: "'EB Garamond', Georgia, serif",
};

const headingStyle = {
  fontFamily: "'Instrument Serif', Georgia, serif",
  fontSize: "1.6rem",
  color: "#c9a961",
  margin: "0 0 12px 0",
};

const buttonStyle = {
  marginTop: "20px",
  padding: "10px 24px",
  background: "#c9a961",
  color: "#1a1a2e",
  border: "none",
  borderRadius: "4px",
  fontSize: "1rem",
  fontFamily: "'EB Garamond', Georgia, serif",
  fontWeight: 600,
  cursor: "pointer",
};

function IdleWarningModal({ secondsLeft, onStayActive }) {
  return (
    <div style={overlayStyle} role="dialog" aria-modal="true">
      <div style={dialogStyle}>
        <h2 style={headingStyle}>Still there?</h2>
        <p style={{ margin: "0 0 8px 0", lineHeight: 1.5 }}>
          For your security, you'll be signed out in
        </p>
        <p style={{ fontSize: "2rem", color: "#c9a961", margin: "8px 0", fontWeight: 600 }}>
          {secondsLeft}s
        </p>
        <p style={{ margin: 0, lineHeight: 1.5, opacity: 0.85 }}>
          due to inactivity.
        </p>
        <button type="button" style={buttonStyle} onClick={onStayActive}>
          Stay signed in
        </button>
      </div>
    </div>
  );
}

export default IdleWarningModal;
